<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">

        <PaymentForm class="form-horizontal">
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>                   
            <FormRow inline>
              <div style="width: 100%">
                <FormLabel class="control-label"> Were you an advisor or alumni? </FormLabel>
                <FormInput
                  type="text"
                  class="width-full"
                  field="custom.advisorOrAlumni"
                />
              </div>
            </FormRow>  

            <FormRow>
              <FormLabel>
                <input type="checkbox" field="custom.anonymous" :checked="anonymous" @click="anonymous = $event.target.checked" /> I
                would like my donation to be listed anonymously.
              </FormLabel>
            </FormRow>
            <br />            
          </FormSection>
        
          <FormSection title="Spouse's Details">
            <FormRow inline>
              <div style="width: 100%">
                <FormLabel class="control-label"> First </FormLabel>
                <FormInput
                  type="text"
                  class="width-full"
                  field="custom.spouseFirstName"
                />
              </div>
              <div style="width: 100%">
                <FormLabel class="control-label"> Last </FormLabel>
                <FormInput type="text" class="width-full" field="custom.spouseLastName" />
              </div>
            </FormRow>
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Swag Shipping Address">
            <FormRow>
            <FormLabel class="control-label">Is this the same address for shipping information for your Swag package?</FormLabel>
          </FormRow>
          <div class="radio-container">      
          <FormLabel class="radio-inline">
                <input
                  id="swag_yes"
                  name="Swag"
                  type="radio"
                  :checked="getValue('custom.SwagSameAddess') == 'yes'"
                  @click="setValue('custom.SwagSameAddess', 'yes')"
                />
                  Yes
                </FormLabel>
                &nbsp;
                    <FormLabel class="radio-inline">
                <input
                  name="Swag"
                  id="swag_no"
                  type="radio"
                  :checked="getValue('custom.SwagSameAddess') == 'no'"
                  @click="setValue('custom.SwagSameAddess', 'no')"
                />
                No
              </FormLabel>                   
                  </div>
                
<div class="second__address" v-if="getValue('custom.SwagSameAddess') == 'no'">
  <br>
<SecondAddress />
</div>
<br>
</FormSection>          
          <FormSection title="Designation">
            <FormLabel class="control-label" style="margin-bottom: 10px">
              Would you like your donation to be directed towards a specific chapter"?
            </FormLabel>

            <NcsyIgniteAtsDesignation />
          </FormSection>
          <FormSection title="">
            <FormRow inline>
              <div style="width: 100%">
                <FormLabel class="control-label">
                  How did you hear about the Ignite Society?
                </FormLabel>
                <FormInput type="textarea" class="width-full" field="custom.hearAboutUs" />
              </div>
            </FormRow>
            <InHonorOf />
          </FormSection>
          <FormSection title="Donation Amount">
            <div>
              <div>
    <div>
      <div class="styled-radio-container styled-radio-container--ou-donation row">
        <div class="radio-part">
          <input
          name="payment"
            id="oneTime"
            type="radio"
            class="frequency"
            :checked="!monthly && getValue('amount') === '1000'"
            @click="
              other = false;
              setValue('dayOfMonth', null);
              setValue('periodMonths', null);
              setValue('amount', '1000');
            "
          />
          <FormLabel for="oneTime">
          <div class="money_format label-amount">$1,000</div>
           <span class="label-description">Single Donation</span></FormLabel>
        </div>
        <div class="radio-part">
          <input
          name="payment"
            id="monthly"
            type="radio"
            class="frequency"
            :checked="monthly && getValue('amount') === '83.33'"
            @click="
            other = false;
              setValue('dayOfMonth', '' + new Date().getDate());
              setValue('amount', '83.33');
              setValue('periodMonths', '12');
            "
          />
          <FormLabel for="monthly">
            <div class="money_format label-amount">$83.33</div>
           <span class="label-description"> Monthly Donation</span>

          </FormLabel>
        </div>
        <div class="radio-part radio__other">
          <input
          name="payment"
            id="other"
            type="radio"
            class="frequency"
            :checked="other"
            @click="
              other = true;
              setValue('dayOfMonth', null);
              setValue('periodMonths', null);
              setValue('amount', '0');
            "
          />
          <FormLabel for="other">
            <div class="other__amount">Other Amount</div>

          </FormLabel>
        </div>
      </div>
    </div>
    <FormRow class="monthly-note" v-if="other">
      <div class="amount_other__wrapper amount-row">
      <input type="number" min="1" name="amount_other" placeholder="Other amount" v-model="customAmount" />
  </div>
    </FormRow>
    <FormRow class="monthly-note" v-if="monthly">
      <div>
        Your donation will be made today and on the <strong>{{ monthDay }}</strong> of
        each following month using the payment method selected. You may change or cancel
        this amount at any time. <br /><br />
      </div>
    </FormRow>
  </div>
              <ErrorLabel field="amount" />
            </div>
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch,
} from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

import { queryParams } from "~/shared/query-params";

export default defineComponent({
  props: {
    subCampaign: String,
  },
  setup(props) {
    const { setValue, getValue, form, submit } = usePaymentForm();
    const other = ref(false);
    const anonymous = ref();

    const customAmount = ref(form.value.amount)

    watch(customAmount, (customAmount) => {
      if (customAmount) {
        setValue('amount', customAmount)
      }
    })

    setValue("custom.SwagSameAddess", "yes")
    watch(anonymous, () => {
      if (anonymous.value) {
        setValue("custom.anonymous", anonymous.value);
      }
    });
    
    watch(
      () => getValue("custom.designation"),
      (val) => {
        if (val == "Baltimore" || !val) {
          setValue("applications.0.campaign", "Baltimore");
        } 
        else if(val == "Greater Washington" || !val) {
          setValue("applications.0.subCampaign", "Greater Washington");
        } 
        else if(val == "NOVA" || !val) {
          setValue("applications.0.subCampaign", "NOVA");
        } 
        else if(val == "Philadelphia" || !val) {
          setValue("applications.0.subCampaign", "Philadelphia");
        } 
        else if(val == "Richmond" || !val) {
          setValue("applications.0.subCampaign", "Richmond");
        } 
        else if(val == "Cherry Hill" || !val) {
          setValue("applications.0.subCampaign", "Cherry Hill");
        } 
        else {
          setValue("applications.0.department", "NCSY_AtlanticSeaboard");
          setValue("applications.0.campaign", "Ignite Legacy Society");
          // setValue("applications.0.campaign", val);
        }
      }
    );

    return {
      form,
      submit,
      anonymous,
      monthly: computed(() => !!form.value.dayOfMonth),
      other,
      getValue,
      setValue,
      customAmount
    };
  },
});
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
::v-deep h2 {
    font-style: normal;
    font-weight: 700 !important;
    font-size: 16px !important;
    margin-bottom: 16px !important;
    line-height: 24px !important;
    color: #080f16 !important;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}

::v-deep.styled-radio-container.styled-radio-container--ou-donation.row {

  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 16px;

  label {
    cursor: pointer;
    height: 100%;
    width: 100%;
    padding: 32px 46px;
    border-radius: 8px;
border: 2px solid  #EEEFF0;
background: #FFF;
    &:hover {
      background: #fafafa;
    }
    @media only screen and (max-width: 500px) {
      padding: 10px 14px;
    }
  }
  input {
    height: 0;
    top: 20px;
    position: absolute;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  .money_format{
    color: #1F262E;
text-align: center;
font-size: 24px;
font-style: normal;
padding-bottom: 10px;
font-weight: 700;
line-height: 24px; 
text-transform: capitalize;
  }
  .other__amount{
    color: #1F262E;
text-align: center;
font-size: 22px;
font-style: normal;
padding-bottom: 0px;
font-weight: 700;
line-height: 22px; 
text-transform: capitalize;
  }
    .label-description {
    color: #9FA4AA;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    }
  input[type="radio"]:checked + label {
    border: 2px solid #1e50b4;
    .money_format {
      color: #1e50b4;
    }
    .label-description {
      color: #080f16;
    }
  }
  .radio__other{
    label{
      display: flex;
      align-items: center;
    }
  }
}
::v-deep .form-container.ou-donation-form {
  margin: 0px auto !important;
    padding: 0px !important;
    border-radius: 0px !important;
    max-width: 100% !important;
    border: none !important;
}

::v-deepbutton#donate-widget-form-submit{
  background: #E56C15;
  border-color: #E56C15;
&:hover{
      background: #C25100;
}
}

.radio-container {
  display: flex;
  gap: 10px;
  align-items: center;
  padding-bottom: 5px;
}

.monthly-note {
  font-size: 13px;
  line-height: 1.4;
  margin-top: 10px;
  display: flex;
  align-items: center;

  .month-limit {
    margin-right: 20px;
    min-width: 110px;
  }
}

input#swag_yes, input#swag_no {
    position: relative;
    margin: 0px 0px 0px;
}

</style>
